import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ContainersIndex } from './pages/ContainersIndex';

const ContainersRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<ContainersIndex />} />
    </Routes>
  );
};

export default ContainersRoutes;